<template>
  <main class="text-notification-picker" data-cy="text-notification-picker">
    <sb-dropdown :items="templates" :selected="selected" v-on:update:selected="$emit('update:selected', $event)" style="width:100%" data-cy="message-template-select">
      <template #label="{ selected }">
        <div v-if="!selected" class="notification-label">
          select sms notification message
        </div>

        <template v-if="selected">
          <div class="notification-label">
            {{ selected.title }}
          </div>
          <div class="notification-label-description">
            {{ selected.message }}
          </div>
        </template>
      </template>

      <template #item="{ item }">
        <div class="notification-item">
          {{ item.title }}
        </div>
        <div class="notification-item-description">
          {{ item.message }}
        </div>
      </template>
    </sb-dropdown>
  </main>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'text-notification-picker',
  props: {

    selected: [ String, Number, Object ],
    templates: Array
  }
}
</script>

<style>
  .data-description b {
    font-size: 1.25rem;
  }
</style>
